import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../components/Common/TextInput';
import CallOut from '../components/Common/CallOut';
import Notification from '../components/Common/Notification';
import ActivityLoader from '../components/Common/ActivityLoader';
import { useBanking } from '../DataStore/BankingContext';
import ajaxBanking from '../util/remote/ajaxBanking';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
        loading:false,
        bankName:'',
        accountNumber:'',
        phoneNumber:'',
        email:'',
        address: '',
}

const NewBank = () => {

    const {getBanks} = useBanking();
    const [currentNotify, setNotify] = useState(null);

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);


    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }
        dispatch({type: 'loading', value: true});
        const server_response = await ajaxBanking.addBank(
            state.bankName, state.accountNumber, state.phoneNumber, state.emailAddress, state.address
        );
        dispatch({type: 'loading', value: false});
        if(server_response?.status === "OK"){
            dispatch({type: 'RESET'});

            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            setTimeout(() => {
                getBanks(true);
            }, 5000);
            
           
            setNotify(<Notification type='success' message={server_response.message} />);
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);
        }

    }


    return (
        <div className="card-body">

            <CallOut 
                title="Banks"
                description="Add your financial institution to start monitoring your bank statements."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>
                           

                        <TextInput
                            type="text"
                            label="Bank Name"
                            placeholder="Bank Name"
                            leftIcon="fa fa-bank"
                            value={state.bankName}
                            onChange={e => dispatch({type: 'bankName', value: e.target.value})}
                            required
                            wrap
                            />


                        <TextInput
                            type="text"
                            label="Account Number"
                            placeholder="Bank Account Number"
                            leftIcon="fa fa-hashtag"
                            value={state.accountNumber}
                            onChange={e => dispatch({type: 'accountNumber', value: e.target.value})}
                            wrap
                            required
                            />
                       


                        <TextInput
                            type="text"
                            label="Bank Address"
                            placeholder="Bank Address or Account Branch"
                            leftIcon="fa fa-map-pin"
                            value={state.address}
                            onChange={e => dispatch({type: 'address', value: e.target.value})}
                            wrap
                            required
                            />
        
                          
                        <TextInput
                            type="text"
                            label="Phone Number"
                            placeholder="Phone Number"
                            leftIcon="fa fa-phone"
                            value={state.phoneNumber}
                            onChange={e => dispatch({type: 'phoneNumber', value: e.target.value})}
                            wrap
                            required
                            />

                        <TextInput
                            type="email"
                            label="Email Address"
                            placeholder="Email Address"
                            leftIcon="fa fa-envelope"
                            value={state.emailAddress}
                            onChange={e => dispatch({type: 'emailAddress', value: e.target.value})}
                            wrap
                            required
                            />


                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-success">Save Bank</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 


        </div>
    );
};

export default NewBank;